import React from 'react';

/**
 * QuestionNavigator — Oblique Design System Component
 * Renders an accessible jump matrix for multiple-choice assessment questions.
 */
export function QuestionNavigator({
  totalQuestions = 0,
  answeredMap = {},
  onSelectQuestion,
  className = ''
}) {
  const pills = Array.from({ length: totalQuestions }, (_, i) => i + 1);

  const handleClick = (questionNum) => {
    if (onSelectQuestion) {
      onSelectQuestion(questionNum);
    } else {
      const el = document.getElementById(`question-card-${questionNum}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <div className="flex items-center justify-between text-[11px] font-semibold text-[var(--text-tertiary)] uppercase tracking-wider">
        <span>Question Jump Grid</span>
        <span>{Object.keys(answeredMap).length}/{totalQuestions} Answered</span>
      </div>

      <div className="grid grid-cols-5 gap-1.5">
        {pills.map((num) => {
          const isAnswered = answeredMap[num - 1] !== undefined || answeredMap[`q${num}`] !== undefined;

          return (
            <button
              key={num}
              type="button"
              onClick={() => handleClick(num)}
              className={`
                h-8 rounded-[8px] border text-[12px] font-bold font-mono transition-all flex items-center justify-center cursor-pointer
                ${isAnswered
                  ? 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/30 hover:bg-emerald-500/20'
                  : 'bg-[var(--bg-subtle)] text-[var(--text-tertiary)] border-[var(--border)] hover:border-[var(--border-strong)] hover:text-[var(--text-primary)]'
                }
              `}
              title={`Jump to Question ${num} (${isAnswered ? 'Answered' : 'Unanswered'})`}
            >
              {num}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default QuestionNavigator;
